export default "__VITE_ASSET__DnrwmLCr__"